module.exports = __webpack_public_path__ + "media/images/no_image-f49c0c1b080d638411f4bdbe930b5a1e.png";